var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hosting-cta-section"},[_c('h2',[_vm._v("Switch to blazing fast web hosting")]),_c('a',{staticClass:"btn btn-default hosting-cta-button",attrs:{"href":_vm.ctaAction}},[_vm._v("Get Started Now")])])}
var staticRenderFns = []

export { render, staticRenderFns }